<template>
  <FormItemWrapper class="summer">
    <FormItemLabel slot="label">
      {{ $t('billTableSideLabelReactiveLT') }}
    </FormItemLabel>
    <Tooltip
      v-if="$t('billTableSideLabelReactiveLT')"
      slot="tooltip"
      :content="$t('billTableSideLabelReactiveLT')"
    />
    <el-input
      v-model="reactiveLT"
      type="number"
      class="summer"
      placeholder=""
    >
      <template slot="append">kVArh</template>
    </el-input>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { onKeydownAllowNumbersOnly } from '@/utils/validation';
import debounce from 'lodash/debounce';
import { Input } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Input);

export default {
  name: 'CalculationReactiveLT',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    reactiveLT: {
      get() {
        return this.$store.state.reactive.reactiveCalculationData.reactiveLT;
      },
      set(value) {
        this.update(value);
      },
    },
  },
  methods: {
    update: debounce(function update(value) {
      this.$store.commit('reactive/SET_REACTIVE_LT', Number(value));
    }, 500),
    onKeydownAllowNumbersOnly,
  },
};
</script>
